import { createContext, useContext } from 'react';

export type SupportPhoneContextType = {
  phone?: string;
  setPhone: (v?: string) => void;
};

const noop = (() => undefined) as (v?: string) => void;

export const SupportPhoneContext = createContext<SupportPhoneContextType>({
  phone: undefined,
  setPhone: noop
});

export const useSupportPhone = () => useContext(SupportPhoneContext);
